import { Component } from '@angular/core';

@Component({
	selector: 'pi-unsupported-asset-classes',
	templateUrl: './unsupported-asset-classes.component.html',
	styleUrls: ['./unsupported-asset-classes.component.scss']
})
export class UnsupportedAssetClassesComponent { }
